module.exports = __webpack_public_path__ + "img/checkmark.5333ce7a.png";